import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsWrapperComponent"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/Breadcrumbs/BreadcurmbWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/offersGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/desktop/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/mobile/footer/index.tsx");
